import AccordionComponent from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import { FC, ReactNode } from 'react'
import { RenderIf } from 'shared/helpers/renderIf'

const Accordion: FC<IAccordionProps> = ({
  title,
  innerText,
  defaultExpanded = false,
  children
}) => {
  return (
    <AccordionComponent defaultExpanded={defaultExpanded}>
      <AccordionSummary expandIcon={<ArrowDropDownIcon />}>{title}</AccordionSummary>
      <AccordionDetails>
        <RenderIf condition={Boolean(innerText)}>
          <p>{innerText}</p>
        </RenderIf>
        {children}
      </AccordionDetails>
    </AccordionComponent>
  )
}

interface IAccordionProps {
  title: string
  innerText?: string
  defaultExpanded?: boolean
  children?: ReactNode
}

export default Accordion
